import { Suspense } from "react";
import CustomLoader from "src/shared_components/CustomLoader";

const withLazyLoad = (Component: any) => (props: any) => {
  return (
    <Suspense fallback={<CustomLoader size={30} />}>
      <Component {...props} />
    </Suspense>
  );
};

export default withLazyLoad;
